import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-5 p-md-5" }
const _hoisted_4 = { class: "p-field p-col-5 p-md-5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Không có thông tin nhân viên. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách nhân viên hỗ trợ" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_DataTable, {
          value: $setup.listEmployee,
          paginator: true,
          stripedRows: "",
          rows: 10,
          rowsPerPageOptions: [10,25,50],
          rowHover: true,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          globalFilterFields: ['fullName','zaloId','teamCode'],
          currentPageReportTemplate: "Có tất cả {totalRecords} nhân viên hỗ trợ",
          filters: $setup.filters,
          "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters) = $event))
        }, {
          paginatorLeft: _withCtx(() => []),
          empty: _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "fullName",
              header: "Họ và tên",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "zaloId",
              header: "Zalo Id"
            }),
            _createVNode(_component_Column, {
              field: "teamCode",
              header: "Khoa/Phòng ",
              sortable: ""
            }),
            _createVNode(_component_Column, { header: "Tuỳ chọn" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_Button, {
                      type: "button",
                      class: "p-button-secondary",
                      label: "Cập nhật",
                      icon: "pi pi-user-edit",
                      onClick: ($event: any) => ($setup.openLink(slotProps.data.id))
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_Button, {
                      type: "button",
                      class: "p-button-danger",
                      label: "Xoá",
                      icon: "pi pi-trash",
                      onClick: ($event: any) => ($setup.deleteEmployee(slotProps.data.id))
                    }, null, 8, ["onClick"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "filters"])
      ])
    ]),
    _: 1
  }))
}